/**
 * Landing query for the Equipment-tab landing grid: every `:Site` in
 * the ontology, with the per-site counts the grid needs in one
 * round-trip.
 *
 * `lineCount`      — direct `Site -[:HAS_LINE]-> Line` children.
 * `equipmentCount` — distinct equipment reachable from any of the
 *                    site's top-level lines OR their `HAS_SUBLINE*0..`
 *                    subtrees via `HAS_EQUIPMENT*1..8` (includes nested
 *                    tooling). Deeply-nested sublines still contribute
 *                    to the headline number.
 *
 * Drained client-side via `drainCypherRows` because the trailing
 * `SKIP toInteger($skip) LIMIT toInteger($pageSize)` is what walks the
 * result one page at a time — see `ontology-api-base.ts` for the full
 * rationale.
 */
export const PLANT_SITES_CYPHER = `
            MATCH (s:Site)
            OPTIONAL MATCH (s)-[:HAS_LINE]->(l:Line)
            WITH s, count(distinct l) AS lineCount
            OPTIONAL MATCH (s)-[:HAS_LINE]->(:Line)-[:HAS_SUBLINE*0..]->(scope:Line)
            OPTIONAL MATCH (scope)-[:HAS_EQUIPMENT*1..8]->(eq:Equipment)
            RETURN s,
                   lineCount,
                   count(distinct eq) AS equipmentCount
            ORDER BY toLower(coalesce(s.name, s.id))
            SKIP toInteger($skip) LIMIT toInteger($pageSize)
          `

/**
 * Lightweight Site id/name drain for pickers that must not depend on the
 * active branch (e.g. Ingest landing). Callers fan this out per branch and
 * merge by `id`.
 */
export const PLANT_SITE_OPTIONS_CYPHER = `
            MATCH (s:Site)
            RETURN s.id AS id, coalesce(s.name, s.id) AS name
            ORDER BY toLower(coalesce(s.name, s.id))
            SKIP toInteger($skip) LIMIT toInteger($pageSize)
          `
